import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router';
import classNames from 'classnames';
import { Icons } from '../base/BootstrapComponents/BootstrapComponents';
import Loader from '../base/Loader/Loader';
import Notifications from '../../modules/Notifications/components/Notifications';
import GlobalConfirmModal from '../../modules/System/components/GlobalConfirmModal';
import { getSystemData } from '../../modules/System/reducer';
import UpdatePeriodSelector from './UpdatePeriodSelector';
import { getLoginProcess } from '../../modules/Authorized/reducer';
import LayoutLegend from './LayoutLegend';
import MiniProfile from './MiniProfile';
import Menu from './Menu';
import SignPopup from '../../modules/System/components/SignPopup';
import ProcessProgressBar from '../../modules/System/components/ProcessProgressBar';
import { InformationFormWrapper } from '../../modules/InformationScreenWrapper/components/InformationFormWrapper';

export default function Layout({ currentRoutesByMenu }) {
  const [lowVisionMode, setLowVisionMode] = useState(false);
  const loginProcess = useSelector(getLoginProcess);
  const { loadApp } = useSelector(getSystemData);

  useEffect(() => {
    window.addEventListener('scroll', window.customEventListener.emit, { capture: true });
    window.addEventListener('mouseup', window.customEventListener.emit, { capture: true });
    return () => {
      window.removeEventListener('scroll', window.customEventListener.emit);
      window.removeEventListener('mouseup', window.customEventListener.emit);
    };
  }, []);

  useEffect(() => {
    document.documentElement.style.fontSize = lowVisionMode ? '20px' : '16px';
  }, [lowVisionMode]);

  return (
    <div className={classNames('main-layout', { 'low-vision-mode': lowVisionMode })}>
      <Notifications />
      <Loader loading={loginProcess || loadApp} global hideScreen={loadApp} />
      <div className="app-container">
        <Menu currentRoutesByMenu={currentRoutesByMenu} />
        <div className="app-content-wrapper custom-scroll-theme">
          <div className="app-content" id="app-content">
            <div className="app-bar">
              <div className="info-block" id="header-info-block" />
              <UpdatePeriodSelector />
              <div className={classNames('glasses-block', { active: lowVisionMode })} onClick={() => setLowVisionMode(!lowVisionMode)}>
                <Icons
                  customIcon
                  className="glasses-icon"
                  icon="glasses"
                />
              </div>
              <LayoutLegend />
              <MiniProfile />
            </div>
            <div className="app-content-children" id="app-content-children">
              <div className="page-wrapper custom-scroll-theme">
                <Outlet />
              </div>
              <InformationFormWrapper />
            </div>
          </div>
        </div>
      </div>
      <GlobalConfirmModal />
      <SignPopup />
      <ProcessProgressBar />
    </div>
  );
}
